import { ProFormUploadButton } from "@ant-design/pro-components";
import { Upload, message, Image } from "antd";
import React, { useState } from "react";
import { postImage } from "../../service/complaint";
import CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";
import Compressor from "compressorjs";

// 脚手架示例组件
const CustomUpload = (props) => {
  const {
    form,
    size = 5,
    width = 0,
    height = 0,
    name,
    extra,
    max,
    label,
    disabled = false,
    accept,
    rules,
  } = props;

  const { id } = useParams();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  console.log("size is", size);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  async function customRequest(option) {
    console.log("option is", option);

    new Compressor(option.file, {
      quality: 0.4,
      convertTypes: ["image/png", "image/webp"],
      convertSize: 2000000,
      // The compression process is asynchronous,
      // which means you have to access the `result` in the `success` hook function.
      success: async (result) => {
        console.log("option is", result);
        const base64ImageData = await readAsDataURL(result);
        const hash = await readAsArrayBuffer(result);
        postImage({
          image_content: base64ImageData,
          image_filename: result.name,
          image_sha256: hash,
          image_type: result.type.replace("image/", ""),
          complain_no: id,
        })
          .then((res) => {
            option?.onSuccess(res?.image_id);
          })
          .catch((e) => {
            option?.onError(e);
            message.error({
              content: "上传错误",
            });
            // option.actions.remove(option.fileList)
          });
      },
      error(err) {
        console.log(err.message);
      },
    });
  }

  async function readAsDataURL(option) {
    return new Promise((reslove, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(option);
      reader.onloadend = function(e) {
        console.log(e.target?.result); // 打印图片的base64
        const result = e.target?.result;
        if (e && e.target && e.target.result) {
          let base64Header = "data:image/png;base64,";
          // 删除头部以获取实际编码数据
          // console.log("atob() is", atob(e.target.result))
          let base64Data = result?.replace(
            /^data:image\/(jpeg|png|gif);base64,/,
            ""
          );
          reslove(base64Data);
        }
      };
    });
  }

  async function readAsArrayBuffer(option) {
    return new Promise((reslove, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(option);
      reader.onloadend = function(e) {
        console.log(e.target?.result); // 打印图片的base64
        const result = e.target?.result;
        if (e && e.target && e.target.result) {
          //将读取结果：文件数据类型：ArrayBuffer 转化 为wordArray格式
          var wordArray = CryptoJS.lib.WordArray.create(result);
          //直接调用SHA256()并转化得到十六进制字符串（也就是我们要的SHA256）
          var hash = CryptoJS.SHA256(wordArray).toString();
          reslove(hash);
        }
      };
    });
  }

  async function handleBeforeUpload(file, fileList) {
    console.log("file is", file);
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error({
        content: "上传类型为 JPG/PNG",
      });
      return Promise.reject(false);
    }
    const isGt30M = file.size / 1024 / 1024 > size;
    
    if (isGt30M) {
      message.error({
        content: `图片不能大于${size}M!`,
      });
      return Promise.reject(false);
    }

    function isValidSize() {
      return new Promise((resolve, reject) => {
        if (width && height) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function(e) {
            console.log(e.target?.result); // 打印图片的base64
            const data = e.target?.result;
            var image = new Image();
            image.onload = function() {
              var imgWidth = image.width;
              var imgHeight = image.height;
              if (imgWidth != width || imgHeight != height) {
                message.error({
                  content: "图片宽高设置不正确!",
                });
                resolve(false);
              }
              resolve(true);
            };
            image.src = data;
          };
        } else {
          resolve(true);
        }
      });
    }

    // const vaildSize = await isValidSize();

    // // console.log("vaildSize is", vaildSize)
    // debugger
    // return (isJpgOrPng && !isGt30M && vaildSize)
  }

  const [preview, setPreview] = useState({
    isOpen: false,
    seeImage: "",
    setTitle: "",
  });

  const [upFileList, setUpFilelist] = useState([]);

  const handleOnChange = (info) => {
    let newFileList = [...info.fileList];
    console.log("newFileList is", newFileList);

    const tempList = newFileList.filter((item) => item.status);
    setUpFilelist(tempList);

    form?.current?.setFieldsValue({
      [name]: tempList,
    });
  };
  // console.log("value is", value);

  return (
    <>
      <ProFormUploadButton
        name={name}
        label={label}
        max={max}
        disabled={disabled}
        rules={rules}
        fileList={upFileList}
        transform={(value, namePath) => {
          return {
            [namePath]: value,
          };
        }}
        fieldProps={{
          name: "file",
          onChange: handleOnChange,
          listType: "picture-card",
          customRequest: customRequest,
          beforeUpload: handleBeforeUpload,
          accept: accept,
          onPreview: handlePreview,

          // action="internal/manager/v1/soft/uploadpic"
          // fileList:fileList,
          // accept:accept,
        }}
        extra={extra}
      />
      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};

export default CustomUpload;
